import React from "react";
import { Monitor, ScanBarcode } from "lucide-react";

const DesktopOnlyNotice = ({ page }) => (
  <div className="min-h-screen bg-background px-4 py-10 flex items-center justify-center" data-testid="desktop-only-notice">
    <div className="w-full max-w-md rounded-2xl border border-border bg-card p-6 text-center shadow-sm">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
        <Monitor className="h-7 w-7" />
      </div>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">Desktop Required</p>
      <h1 className="mt-2 text-xl font-bold">{page?.label || "This module"}</h1>
      <p className="mt-3 text-sm leading-6 text-muted-foreground">This module is optimized for desktop. Use the supported mobile workflows for shop-floor actions.</p>
      <div className="mt-6 grid gap-3">
        <a href="/dashboard" className="inline-flex min-h-11 items-center justify-center rounded-lg bg-primary px-4 text-sm font-semibold text-primary-foreground">Back to Command Center</a>
        {page?.domain === "oms" && (
          <a href="/return-scan" className="inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border border-border px-4 text-sm font-semibold">
            <ScanBarcode className="h-4 w-4" /> Open Return Scanning
          </a>
        )}
      </div>
    </div>
  </div>
);

export default DesktopOnlyNotice;
